import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { trackClick } from '../utils/analytics';

export const useTracking = () => {
  const location = useLocation();

  const trackButtonClick = useCallback((buttonName, additionalData = {}) => {
    trackClick('button', buttonName, location.pathname, additionalData);
  }, [location.pathname]);

  const trackLinkClick = useCallback((linkName, additionalData = {}) => {
    trackClick('link', linkName, location.pathname, additionalData);
  }, [location.pathname]);

  return { trackButtonClick, trackLinkClick };
}; 